import React from "react";
import { Box } from "@mui/material";
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import homeSidebarStyle from "src/Assets/css/home/Homepagerightsidebar.module.css";
import Contributors from "src/pages/HomePage/components/Contributors";
import styles from "./ViewActBeforeSignIn.module.css";
import useStyles from "./styles";
import forwardIcon from "src/Assets/images/Next-Button.svg";
import arrowSvg from "src/Assets/images/arrowSvg.svg";
import AvatarBadge from "src/Components/AvatarBadge";
import style from "src/Assets/css/home/Homepagerightsidebar.module.css";
import alreadyImpactfulMemberImg from "src/Assets/images/already_impactful_img.png";
import inviteToBeImapctFullMemberImage from "src/Assets/images/impactful_nominate_img_new.png";

const profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;

function RightSide({
  contributors,
  handleClickEvent,
  showBio,
  contributorBio,
  isSignIn,
  isEnable,
  isTagTempData,
  isAskTempData,
  handleSeeAll,
  pageType,
  distFromTop,
  pointerLeft,
  cancelHide,
  scheduleHide,
}) {
  const { shareUpdate } = useStyles();

  return (
    <div>
      <div>
        <Contributors style={{marginLeft: "10px"}}
          handleClickEvent={handleClickEvent}
          contributorsData={contributors}
          pageType={pageType}
        />
        {showBio && (
          <div
            className={style.profilehover}
            style={{
              top: distFromTop,
              zIndex: 1000,
              "--pointer-left": pointerLeft,
            }}
            onMouseEnter={cancelHide}
            onMouseLeave={scheduleHide}
          >
            
            <div className={feedstyles.profilehoverimageandcount}>
              <div>
                <AvatarBadge 
                  src={`${profileImagePath}${contributorBio?.uImage}`}
                  className={styles.avatar}
                  isPrimaryModerator={String(contributorBio.isPM) === "1"}
                  isModerator={
                    String(contributorBio.isModerator) === "1" &&
                    String(contributorBio.isPM) === "0"
                  }
                />
              </div>
           
              <div style={{ marginLeft: "10px" }}>
                <span className={feedstyles.profilename}>
                  {contributorBio?.displayName}
                  {(contributorBio?.isImpactableMember === "yes" ||
                    contributorBio?.mainuserdata?.isImpactableMember === "yes") && (
                    <img
                      src={alreadyImpactfulMemberImg}
                      alt="Impactful Member"
                      title="Impactful Member"
                      style={{
                        width: "18px",
                        height: "18px",
                        objectFit: "contain",
                        flexShrink: 0,
                        marginLeft: "5px",
                      }}
                    />
                  )}
                </span>
                <p className={feedstyles.profilecount}>
                  SAYs {contributorBio?.say} | UPDATEs {contributorBio?.iUpdate}{" "}
                  | ANSWERs {contributorBio?.answer}
                </p>
              </div>
              <button
                type="button"
                disabled
                style={{
                  padding: 0,
                  margin: 0,
                  border: "none",
                  background: "transparent",
                  cursor: "default",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  outline: "none",
                  pointerEvents: "none",
                }}
              >
                <img
                  src={inviteToBeImapctFullMemberImage}
                  alt="Invite"
                  style={{
                    width: "23px",
                    height: "23px",
                    objectFit: "contain",
                    display: "block",
                  }}
                />
              </button>
            </div>
            <p style={{ margin: 0 }}>{contributorBio?.shortBio}</p>
          </div>
        )}
      </div>

      <Box
        className={shareUpdate}
        onClick={() => {}}
        style={{
          cursor: isSignIn && !isEnable ? "pointer" : "not-allowed",
        }}
        bgcolor="#ffffff"
      >
        <h5 className={`h17 bold dark-gray`}>Share UPDATE</h5>
        <img src={arrowSvg} alt="arrow" width="50" height="54" />
      </Box>
      <Box
        className={shareUpdate}
        onClick={() => {}}
        style={{
          cursor: isSignIn && !isEnable ? "pointer" : "not-allowed",
        }}
      >
        <h5 className={`h17 bold dark-gray`}>Create TAG</h5>
        <img src={arrowSvg} alt="arrow" width="50" height="54" />
      </Box>
      <div className={homeSidebarStyle.Trending}>
        <h2>See what is trending</h2>
        <div className={homeSidebarStyle.tagSection}>
          <h6>TAGs</h6>
          {isTagTempData && Object.keys(isTagTempData).length !== 0 ? (
            <div>
              {isTagTempData.map((trendinglist) => (
                <div
                  key={trendinglist.id}
                  className={homeSidebarStyle.trendingTagNameContainer}
                >
                  <p> {trendinglist.hash_tag_name} </p>
                  {trendinglist.Keyword_ID === "X" && (
                    <div className={homeSidebarStyle.trendingTagPrivateStatus}>
                      P
                    </div>
                  )}
                </div>
              ))}
              <a
                href="#tags"
                className={homeSidebarStyle.Seemore}
                onClick={(e) => {
                  e.preventDefault();
                  handleSeeAll("tags");
                }}
              >
                See All{" "}
                <img src={forwardIcon} alt="forward-Icon" className="ml-2" />
              </a>
            </div>
          ) : (
            <p className={homeSidebarStyle.message}>No Tags are Trending</p>
          )}
        </div>

        <div className={homeSidebarStyle.asksection}>
          <h6>ASKs</h6>
          {isAskTempData && Object.keys(isAskTempData).length !== 0 ? (
            isAskTempData?.map((trendinglist) => (
              <ul
                className={homeSidebarStyle.asks}
                key={`trendingask-key-${trendinglist?.id}`}
                onClick={() => handleSeeAll("asks")}
              >
                <li>
                  <AvatarBadge
                    variant="square"
                    src={
                      trendinglist?.uimage
                        ? `${profileImagePath}${trendinglist.uimage}`
                        : process.env.REACT_APP_DUMMY_PROFILE_IMAGE
                    }
                    className={homeSidebarStyle.askavatar}
                    isPrimaryModerator={
                      String(trendinglist?.isPM) === "1" ||
                      String(trendinglist?.mainuserdata?.isPM) === "1"
                    }
                    isModerator={
                      (String(trendinglist?.isModerator) === "1" ||
                        String(trendinglist?.mainuserdata?.isModerator) === "1") &&
                      !(
                        String(trendinglist?.isPM) === "1" ||
                        String(trendinglist?.mainuserdata?.isPM) === "1"
                      )
                    }
                    size={45}
                  />
                  <div className={homeSidebarStyle.askprofilecontnet}>
                    <p className={homeSidebarStyle.askprofilecontnetName}>
                      {trendinglist.displayName}
                    </p>
                    <p className={homeSidebarStyle.askprofilecontnetMessage}>
                      {trendinglist?.Message}
                    </p>
                  </div>
                </li>
              </ul>
            ))
          ) : (
            <p>No Data</p>
          )}
          <a
            href="#asks"
            className={homeSidebarStyle.Seemore}
            onClick={(e) => {
              e.preventDefault();
              handleSeeAll("asks");
            }}
          >
            See All{" "}
            <img src={forwardIcon} alt="forward-Icon" className="ml-2" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default RightSide;
